import React from 'react'
import { addCommasToNumber, Vertical, NothingMessage, Texto } from '@gravitate-js/excalibrr'
import { LoadingOutlined } from '@ant-design/icons'
import {
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Area,
  ComposedChart,
  ReferenceLine,
} from 'recharts'
export const chartColors = ['#102643', '   #76abf3', '  #cce5ff', '#8dabc4']

export const HourlyChart = ({ ordersLoading, chartData, chartType }) => {
  return (
    <Vertical flex={chartType === 'all' ? 1 : 1.5} border='all' background='bg-2' className=' py-3'>
      <Vertical>
        {chartType === 'all' && (
          <Texto appearance='medium' weight='bold' className='pb-5 pt-3 px-4'>
            HOURLY VOLUME
          </Texto>
        )}
        {ordersLoading ? (
          <Vertical verticalCenter horizontalCenter>
            <Texto align='center' appearance='secondary' className='mb-3' category='h3'>
              <LoadingOutlined />
            </Texto>
            {chartType === 'all' && (
              <Texto category='h5' appearance='secondary'>
                Grabbing Hourly Summary For The Day
              </Texto>
            )}
          </Vertical>
        ) : (
          <HourlyBarChart chartType={chartType} chartData={chartData} />
        )}
      </Vertical>
    </Vertical>
  )
}
export const HourlyBarChart = ({ chartData }) => {
  if (!chartData) {
    return <NothingMessage message='No Hourly Volume. Orders will need to be scheduled to view this metric.' />
  }
  const chartConfig = {
    keys: ['loaded', 'scheduled'],
    colors: chartColors,
  }
  return (
    <ResponsiveContainer width='100%' height='100%'>
      <ComposedChart
        data={chartData.volumes}
        margin={{
          top: 20,
          right: 30,
          left: 30,
        }}
      >
        <CartesianGrid stroke='#f5f5f5' />
        <XAxis dataKey='date' scale='band' type='category' />
        <YAxis
          tickFormatter={(value) => addCommasToNumber(value, 0)}
          yAxisId='left'
          label={{ value: 'Hourly Volume', angle: -90, position: 'insideLeft' }}
        />
        <YAxis
          tickFormatter={(value) => addCommasToNumber(value, 0)}
          yAxisId='right'
          orientation='right'
          label={{ value: 'Volume Buildup', angle: -270, position: 'insideRight' }}
          domain={[0, chartData.directiveMax * 1.1]}
        />
        <Tooltip formatter={(value) => addCommasToNumber(value, 0)} />

        <Area type='monotone' yAxisId='right' dataKey='total' fill={chartColors[2]} stroke={chartColors[2]} />
        {chartConfig.keys.map((key, i) => (
          <Bar
            barSize={10}
            key={i}
            radius={[3, 3, 0, 0]}
            dataKey={key}
            yAxisId='left'
            stackId='a'
            fill={chartConfig.colors[i]}
          />
        ))}
        {chartData.directiveMin && (
          <ReferenceLine
            yAxisId='right'
            y={chartData.directiveMin}
            label='Directive Min'
            stroke='#c79c02'
            strokeDasharray='3 3'
          />
        )}
        {chartData.directiveMax && (
          <ReferenceLine
            yAxisId='right'
            y={chartData.directiveMax}
            label='Directive Max'
            stroke='#c79c02'
            strokeDasharray='3 3'
          />
        )}
      </ComposedChart>
    </ResponsiveContainer>
  )
}
